// extracted by mini-css-extract-plugin
export var adjacentSlide = "_qs-9";
export var arrowButtonContainer = "_qs-5";
export var arrowButtonIcon = "_qs-6";
export var carouselArrowButton = "_qs-2";
export var carouselElementContainer = "_qs-1";
export var currentSlide = "_qs-8";
export var left = "_qs-3";
export var otherSlide = "_qs-a";
export var productCarouselContainer = "_qs-0";
export var right = "_qs-4";
export var sliderOverflow = "_qs-7";